import { NgModule } from '@angular/core';

import { PrizmMapperPipe } from './mapper.pipe';

@NgModule({
  exports: [PrizmMapperPipe],
  declarations: [PrizmMapperPipe],
})
export class PrizmMapperPipeModule {}
